var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "bulma-table",
    {
      staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
      attrs: {
        columns: _vm.columns,
        "page-index": _vm.filter.pageIndex,
        "page-size": _vm.filter.pageSize,
        "total-rows": _vm.totalRows,
        "is-loading": _vm.isTableLoading,
        "sort-column": _vm.filter.sortColumn,
        "sort-order": _vm.filter.sortOrder,
        draggable: false,
        "show-pagination": false,
      },
      on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
    },
    [
      _vm._l(_vm.activeItems, function (item, index) {
        return _c(
          "tr",
          {
            key: item.quoteItemId,
            on: {
              click: function ($event) {
                return _vm.highlightSelected(index, $event)
              },
            },
          },
          [
            _c(
              "td",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$userInfo.isSupportUser,
                    expression: "$userInfo.isSupportUser",
                  },
                ],
                staticClass: "has-vertical-middle has-text-right",
              },
              [_c("span", [_vm._v(_vm._s(item.lineNumber))])]
            ),
            _c("td", { staticClass: "has-vertical-middle" }, [
              _c("span", [_vm._v(_vm._s(item.itemNo))]),
            ]),
            _c("td", { staticClass: "has-vertical-middle" }, [
              _c("span", [_vm._v(_vm._s(item.itemDesc))]),
            ]),
            _c("td", { staticClass: "has-vertical-middle has-text-centered" }, [
              _c("span", { staticClass: "icon has-text-info" }, [
                _c("i", {
                  staticClass: "mdi mdi-24px",
                  class: [item.reportOnly ? "mdi-check" : ""],
                }),
              ]),
            ]),
            _c(
              "td",
              {
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v("0")]
            ),
            _c(
              "td",
              {
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v("0")]
            ),
            _c(
              "td",
              { staticClass: "has-vertical-middle has-text-right money-input" },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatNumber(
                        item.value,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ]),
              ]
            ),
            _c("td", { staticClass: "has-vertical-middle has-text-centered" }, [
              item.presentAs
                ? _c(
                    "div",
                    _vm._l(item.presentAs, function (split) {
                      return _c("div", { key: split.itemType }, [
                        _c(
                          "div",
                          {
                            staticClass: "tags has-addons mb-0 present-as-tags",
                          },
                          [
                            _c(
                              "span",
                              {
                                class: `tag mb-1 is-${split.itemType.toLowerCase()}`,
                              },
                              [_vm._v(_vm._s(split.itemType))]
                            ),
                            _c("span", { staticClass: "tag is-dark mb-1" }, [
                              _vm._v(_vm._s(split.percent) + "%"),
                            ]),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
            _c(
              "td",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$userInfo.isSupportUser,
                    expression: "$userInfo.isSupportUser",
                  },
                ],
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v(_vm._s(item.itemStatus))]
            ),
          ]
        )
      }),
      _c("template", { slot: "empty" }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c("span", { attrs: { icon: "icon is-large" } }, [
                _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
              ]),
              _c("p", [_vm._v("Nothing")]),
            ]
          ),
        ]),
      ]),
      _c("template", { slot: "footer" }, [
        _c("tr", [
          _c(
            "th",
            {
              staticClass: "has-text-right has-text-success",
              attrs: { colspan: _vm.totalColSpan },
            },
            [_vm._v("Totals")]
          ),
          _c(
            "th",
            {
              staticClass: "has-text-right has-text-success",
              class: [
                _vm.innerValue.miscTotal >= 0
                  ? "has-text-success"
                  : "has-text-danger",
              ],
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$filters.formatCurrency(
                    _vm.innerValue.miscTotal,
                    _vm.$userInfo.locale
                  )
                )
              ),
            ]
          ),
          _c("th", { attrs: { colspan: "0" } }),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }